import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ExternalLink, Save } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";
import { PageHeader, Panel, DarkBtn, Field } from "@/components/admin/AdminUI";

export default function LegalPages() {
  const [pages, setPages] = useState([]);
  const [slug, setSlug] = useState("");
  const [page, setPage] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/pages").then(({ data }) => {
      setPages(data);
      if (data[0]) setSlug(data[0].slug);
    });
  }, []);

  useEffect(() => {
    if (slug) api.get(`/pages/${slug}`).then(({ data }) => setPage(data));
  }, [slug]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/admin/pages/${slug}`, { title: page.title, content: page.content });
      toast.success("Metin kaydedildi");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-legal-page">
      <PageHeader title="Yasal Metinler" desc="KVKK, çerez, gizlilik, açık rıza ve kullanım koşulları. {company}, {address}, {phone}, {kep} alanları Site Ayarları'ndaki bilgilerle otomatik doldurulur." />
      <div className="grid lg:grid-cols-[260px_1fr] gap-6">
        <Panel className="p-2 h-fit">
          {pages.map((p) => (
            <button key={p.slug} onClick={() => setSlug(p.slug)} className={`w-full text-left rounded-md px-3 py-2.5 text-sm ${slug === p.slug ? "bg-[#1A1513] text-[#D4AF37]" : "hover:bg-[#F3EDE2]"}`} data-testid={`admin-legal-select-${p.slug}`}>{p.title}</button>
          ))}
        </Panel>
        {page && (
          <Panel className="p-5 space-y-4">
            <Field label="Başlık"><Input value={page.title} onChange={(e) => setPage({ ...page, title: e.target.value })} data-testid="admin-legal-title-input" /></Field>
            <Field label="İçerik" hint="'## ' ile başlayan satır başlık, '- ' ile başlayan satır madde olur. Paragrafları boş satırla ayırın.">
              <Textarea rows={22} value={page.content} onChange={(e) => setPage({ ...page, content: e.target.value })} className="font-mono text-xs" data-testid="admin-legal-content-input" />
            </Field>
            <div className="flex gap-3">
              <DarkBtn onClick={save} disabled={saving} data-testid="admin-legal-save-btn"><Save size={16} /> Kaydet</DarkBtn>
              <Link to={`/yasal/${slug}`} target="_blank" className="inline-flex items-center gap-2 text-sm text-[#9E7B27]" data-testid="admin-legal-preview-link"><ExternalLink size={14} /> Önizle</Link>
            </div>
          </Panel>
        )}
      </div>
    </div>
  );
}
